import {
  REPORT_ERROR,
  CLEAR_ERRORS,
  REPORT_SUCCESS,
  CLEAR_SUCCESS,
} from "../actions/erroractions.js";

const initialState = {
  errors: [],
  successMessage: null,
};

export function errorReducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case REPORT_ERROR:
      const errorsCopy = state.errors.slice();
      errorsCopy.push(action.error);
      nextState.errors = errorsCopy;
      return nextState;
    case CLEAR_ERRORS:
      nextState.errors = [];
      return nextState;
    case REPORT_SUCCESS:
      nextState.successMessage = action.successMessage;
      return nextState;
    case CLEAR_SUCCESS:
      nextState.successMessage = null;
      return nextState;
    default:
      return state;
  }
}
